import React from "react"
import PropTypes from "prop-types"
import i18n from "i18n"
import {
  Radio,
  FormControlLabel,
  Grid,
  Switch,
  Paper,
  Typography,
} from "@mui/material"
import TextFieldNumber from "common/TextFieldNumber"
import { useMarginsDiscounts } from "hooks/margin/useMarginsDiscounts"
import { EXTRA, GENERAL } from "context/margin/MarginsDiscountsReducer"

const DiscountTab = ({ isBudgetClosed = false }) => {
  const {
    state,
    setGeneralDiscount,
    setAddExtraDiscountPercentage,
    setOverrideDiscounts,
    setDiscountAccordionSelected,
  } = useMarginsDiscounts()
  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
          {/* General Discount Block */}
          <FormControlLabel
            checked={state.discounts.accordionSelected === GENERAL}
            disabled={isBudgetClosed}
            control={
              <Radio checked={state.discounts.accordionSelected === GENERAL} />
            }
            label={i18n.t("discountTab.addGeneralDiscountTitle")}
            onChange={e => {
              e.stopPropagation()
              setDiscountAccordionSelected(GENERAL)
            }}
          />
          <Grid container item spacing={2} sx={{ mb: 2 }}>
            <Grid item xs={6}>
              <TextFieldNumber
                disabled={
                  isBudgetClosed ||
                  state.discounts.accordionSelected !== GENERAL
                }
                label={i18n.t("discountTab.addGeneralDiscount")}
                value={state.discounts.generalDiscount}
                onChange={e => setGeneralDiscount(e)}
                isPercentage
              />
            </Grid>
            <Grid
              item
              xs={6}
              sx={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <FormControlLabel
                disabled
                control={
                  <Switch
                    checked={state.discounts.overrideDiscounts}
                    onChange={event =>
                      setOverrideDiscounts(event.target.checked)
                    }
                    sx={{ marginRight: 1 }}
                  />
                }
                label={i18n.t("discountTab.overwrite")}
                sx={{
                  alignItems: "center",
                  "& .MuiFormControlLabel-label": {
                    verticalAlign: "middle",
                  },
                }}
              />
            </Grid>
          </Grid>
          {/* Extra Discount Block */}
          <FormControlLabel
            checked={state.discounts.accordionSelected === EXTRA}
            disabled={isBudgetClosed}
            control={
              <Radio checked={state.discounts.accordionSelected === EXTRA} />
            }
            label={i18n.t("discountTab.addExtraDiscount")}
            onChange={() => {
              setDiscountAccordionSelected(EXTRA)
            }}
          />
          <Grid container item spacing={2}>
            <Grid item xs={6}>
              <TextFieldNumber
                disabled={
                  isBudgetClosed || state.discounts.accordionSelected !== EXTRA
                }
                label={i18n.t("discountTab.addExtraDiscountPercentage")}
                value={state.discounts.addExtraDiscountPercentage}
                onChange={e => setAddExtraDiscountPercentage(e)}
                isPercentage
              />
            </Grid>
          </Grid>
        </Paper>
      </Grid>
    </Grid>
  )
}

DiscountTab.propTypes = {
  isBudgetClosed: PropTypes.bool,
}

export default DiscountTab
